import {connect} from 'react-redux';
import Action from '../../redux/Actions';
import FilterTabs, {FilterTabsProps} from './FilterTabs';
import ReduxState from '../../types/ReduxState';
import {Dispatch} from 'redux';
import {RouteComponentProps, withRouter} from 'react-router';

const mapStateToProps = (state: ReduxState, ownProps: RouteComponentProps): Partial<FilterTabsProps> => {
   return {
      ...ownProps,
      dashboardFilter: state.dashboardFilter
   };
};

const mapDispatchToProps = (dispatch: Dispatch<ReduxState>): Partial<FilterTabsProps> => {
   return {
      setDashboardFilter: filter => {
         dispatch(Action.setDashboardFilter(filter));
      }
   };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FilterTabs));
